module.exports = __webpack_public_path__ + "assets/0107_IFOK_WIM_MAIN_More_info_button_for_svg_je Kopie-01.16d975fa.svg";